export interface Movie {
  id: string;
  title: string;
  category: string;
  year: number;
  rating: number;
  image: string;
  description: string;
  director: string;
  actors: string;
  type: 'movie' | 'tv';
}

export const categories = [
  { slug: 'dongzuo', name: '动作片', icon: 'ri-fire-line' },
  { slug: 'xiju', name: '喜剧片', icon: 'ri-emotion-laugh-line' },
  { slug: 'aiqing', name: '爱情片', icon: 'ri-heart-line' },
  { slug: 'kehuan', name: '科幻片', icon: 'ri-rocket-line' },
  { slug: 'kongbu', name: '恐怖片', icon: 'ri-ghost-line' },
  { slug: 'donghua', name: '动画片', icon: 'ri-movie-line' },
  { slug: 'juqing', name: '剧情片', icon: 'ri-file-text-line' },
  { slug: 'xuanyi', name: '悬疑片', icon: 'ri-search-eye-line' },
];

export const movies: Movie[] = [
  {
    id: 'movie-1',
    title: '暗夜追踪',
    category: 'dongzuo',
    year: 2025,
    rating: 8.7,
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20movie%20poster%20for%20a%20thriller%20action%20film%2C%20dark%20urban%20night%20scene%20with%20neon%20lights%2C%20a%20silhouetted%20figure%20in%20trench%20coat%20walking%20through%20rain-slicked%20streets%2C%20dramatic%20lighting%2C%20film%20grain%20texture%2C%20professional%20movie%20poster%20composition%2C%20intense%20mood&width=600&height=840&seq=movie-poster-01&orientation=portrait',
    description: '一名退役特种兵在深夜的城市中追踪一个神秘犯罪组织，揭开了一场惊天阴谋。',
    director: '陈凯风',
    actors: '刘德华, 张震, 周迅',
    type: 'movie',
  },
  {
    id: 'movie-2',
    title: '欢乐一家人',
    category: 'xiju',
    year: 2025,
    rating: 8.2,
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20family%20comedy%20movie%20poster%20featuring%20a%20large%20Chinese%20family%20gathering%20around%20a%20dinner%20table%2C%20bright%20cheerful%20colors%2C%20festive%20atmosphere%2C%20everyone%20laughing%20and%20smiling%2C%20modern%20Chinese%20home%20interior%2C%20professional%20movie%20poster%20design%2C%20clean%20composition&width=600&height=840&seq=movie-poster-02&orientation=portrait',
    description: '一个四世同堂的大家庭在春节期间的爆笑日常，温馨又治愈。',
    director: '王晶',
    actors: '沈腾, 马丽, 艾伦',
    type: 'movie',
  },
  {
    id: 'movie-3',
    title: '星际迷途',
    category: 'kehuan',
    year: 2025,
    rating: 9.1,
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20science%20fiction%20movie%20poster%2C%20a%20spaceship%20floating%20above%20an%20alien%20planet%20with%20purple%20rings%2C%20stars%20and%20nebula%20in%20the%20background%2C%20astronaut%20figure%20in%20foreground%2C%20epic%20scale%2C%20professional%20film%20poster%20design%2C%20dramatic%20lighting&width=600&height=840&seq=movie-poster-03&orientation=portrait',
    description: '人类在探索外太空时意外发现了一个隐藏的文明，冒险就此展开。',
    director: '郭帆',
    actors: '吴京, 李雪健, 赵今麦',
    type: 'movie',
  },
  {
    id: 'movie-4',
    title: '午夜铃声',
    category: 'kongbu',
    year: 2024,
    rating: 7.9,
    image: 'https://readdy.ai/api/search-image?query=A%20horror%20movie%20poster%20with%20a%20dark%20moody%20atmosphere%2C%20an%20old%20rotary%20phone%20on%20a%20wooden%20table%20in%20dim%20lighting%2C%20shadows%20in%20the%20background%2C%20creepy%20and%20mysterious%20vibe%2C%20professional%20film%20poster%20design%2C%20vintage%20horror%20aesthetic&width=600&height=840&seq=movie-poster-04&orientation=portrait',
    description: '一栋老宅中每到午夜便会响起诡异的电话铃声，接听的人逐一失踪。',
    director: '温子仁',
    actors: '张子枫, 彭于晏, 舒淇',
    type: 'movie',
  },
  {
    id: 'movie-5',
    title: '夏日恋歌',
    category: 'aiqing',
    year: 2025,
    rating: 8.0,
    image: 'https://readdy.ai/api/search-image?query=A%20romantic%20movie%20poster%20featuring%20a%20couple%20walking%20on%20a%20beach%20at%20sunset%2C%20golden%20hour%20warm%20lighting%2C%20soft%20and%20dreamy%20atmosphere%2C%20gentle%20waves%20in%20background%2C%20professional%20film%20poster%20design%2C%20elegant%20composition&width=600&height=840&seq=movie-poster-05&orientation=portrait',
    description: '两个年轻人在海边小镇邂逅，从陌生到相爱，谱写了一段难忘的夏日恋曲。',
    director: '张艺谋',
    actors: '刘昊然, 周冬雨, 易烊千玺',
    type: 'movie',
  },
  {
    id: 'movie-6',
    title: '龙之传说',
    category: 'donghua',
    year: 2025,
    rating: 9.3,
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20animated%20film%20poster%2C%20a%20majestic%20dragon%20soaring%20through%20clouds%20above%20ancient%20Chinese%20temples%2C%20vibrant%20colors%2C%20traditional%20Chinese%20art%20style%20blended%20with%20modern%203D%20animation%2C%20epic%20and%20mythical%20atmosphere%2C%20professional%20poster%20design&width=600&height=840&seq=movie-poster-06&orientation=portrait',
    description: '少年踏上寻找龙族秘密的旅程，在冒险中领悟勇气与友谊的真谛。',
    director: '饺子',
    actors: '杨天翔, 季冠霖, 张杰',
    type: 'movie',
  },
  {
    id: 'movie-7',
    title: '迷雾深林',
    category: 'xuanyi',
    year: 2025,
    rating: 8.5,
    image: 'https://readdy.ai/api/search-image?query=A%20mystery%20thriller%20movie%20poster%2C%20a%20dense%20foggy%20forest%20with%20a%20single%20figure%20holding%20a%20flashlight%2C%20mysterious%20atmosphere%2C%20shafts%20of%20light%20breaking%20through%20trees%2C%20suspenseful%20mood%2C%20professional%20film%20poster%20design&width=600&height=840&seq=movie-poster-07&orientation=portrait',
    description: '五位好友深入森林探险，却发现身边同伴一个个离奇消失。',
    director: '忻钰坤',
    actors: '段奕宏, 王宝强, 谭卓',
    type: 'movie',
  },
  {
    id: 'movie-8',
    title: '逆流而上',
    category: 'juqing',
    year: 2025,
    rating: 8.8,
    image: 'https://readdy.ai/api/search-image?query=A%20drama%20film%20poster%20showing%20a%20determined%20person%20rowing%20a%20small%20boat%20against%20strong%20river%20currents%2C%20dramatic%20sky%20with%20storm%20clouds%2C%20powerful%20emotional%20tone%2C%20professional%20movie%20poster%20design%2C%20inspiring%20and%20moving%20composition&width=600&height=840&seq=movie-poster-08&orientation=portrait',
    description: '一位普通工人在逆境中不屈不挠，用双手改变了自己的命运。',
    director: '贾樟柯',
    actors: '王景春, 咏梅, 黄轩',
    type: 'movie',
  },
  {
    id: 'tv-1',
    title: '大秦风云',
    category: 'juqing',
    year: 2025,
    rating: 9.0,
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20historical%20TV%20drama%20poster%20set%20in%20ancient%20China%2C%20majestic%20palace%20and%20warriors%20in%20traditional%20armor%2C%20epic%20battle%20scene%20in%20background%2C%20golden%20and%20red%20color%20palette%2C%20professional%20series%20poster%20design&width=600&height=840&seq=tv-poster-01&orientation=portrait',
    description: '讲述秦始皇统一六国的宏大史诗，再现千年帝国崛起之路。',
    director: '李少红',
    actors: '陈道明, 张丰毅, 孙俪',
    type: 'tv',
  },
  {
    id: 'tv-2',
    title: '都市夜话',
    category: 'aiqing',
    year: 2025,
    rating: 8.3,
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20urban%20romance%20TV%20series%20poster%2C%20a%20stylish%20couple%20in%20a%20city%20rooftop%20setting%20at%20night%2C%20city%20lights%20and%20skyline%20in%20background%2C%20fashionable%20and%20romantic%20vibe%2C%20professional%20series%20poster%20design&width=600&height=840&seq=tv-poster-02&orientation=portrait',
    description: '五位都市年轻人的工作与爱情故事，展现现代都市生活的酸甜苦辣。',
    director: '汪俊',
    actors: '杨幂, 李现, 迪丽热巴',
    type: 'tv',
  },
  {
    id: 'tv-3',
    title: '极限追击',
    category: 'dongzuo',
    year: 2024,
    rating: 8.6,
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20action%20TV%20series%20poster%2C%20a%20police%20officer%20running%20through%20a%20busy%20market%2C%20dynamic%20action%20scene%2C%20explosive%20elements%2C%20intense%20expression%2C%20professional%20series%20poster%20design%2C%20cinematic%20quality&width=600&height=840&seq=tv-poster-03&orientation=portrait',
    description: '刑侦队长追捕跨境犯罪集团，步步惊心的破案过程令人屏息。',
    director: '五百',
    actors: '张译, 王千源, 李现',
    type: 'tv',
  },
  {
    id: 'tv-4',
    title: '仙途',
    category: 'kehuan',
    year: 2025,
    rating: 8.9,
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20fantasy%20TV%20series%20poster%2C%20a%20cultivator%20flying%20on%20a%20sword%20above%20misty%20mountains%2C%20magical%20energy%20effects%2C%20traditional%20Chinese%20fantasy%20aesthetic%2C%20ethereal%20and%20mystical%20atmosphere%2C%20professional%20series%20poster%20design&width=600&height=840&seq=tv-poster-04&orientation=portrait',
    description: '一位平凡少年偶然踏入修仙世界，在历练中成长为一方大能。',
    director: '郑晓龙',
    actors: '肖战, 王一博, 赵丽颖',
    type: 'tv',
  },
];

export const getMoviesByCategory = (categorySlug: string): Movie[] => {
  return movies.filter((m) => m.category === categorySlug);
};

export const getMovieById = (id: string): Movie | undefined => {
  return movies.find((m) => m.id === id);
};

export const getLatestMovies = (count: number = 8): Movie[] => {
  return movies.filter((m) => m.type === 'movie').slice(0, count);
};

export const getPopularTVSeries = (count: number = 4): Movie[] => {
  return movies.filter((m) => m.type === 'tv').slice(0, count);
};